// @ts-nocheck
import type {
  ApiResponse,
  CreateTransactionParams,
  TransactionResponse,
} from "@/types/transaction.type";
import { getStoredUserData } from "@/utils/getStoredUser";
import axios from "axios";
import { th } from "zod/v4/locales";

// KODE ASLI 
// const mapTransactionParams = (params: CreateTransactionParams) => {


//   // Mapping payment method → channelId
//   const paymentChannelMap: Record<string, number> = {
//     Cash: 1,
//     QRIS: 2,
//     Transfer: 3
//   };

//   // Format date - handle both YYYY-MM-DD and DD/MM/YYYY
//   const formatDate = (dateStr: string): string => {
//     try {
//       // Cek apakah sudah format YYYY-MM-DD (dari input type="date")
//       if (dateStr.match(/^\d{4}-\d{2}-\d{2}$/)) {
//         return dateStr; // Sudah format yang benar, return langsung
//       }

//       // Jika format DD/MM/YYYY, convert ke YYYY-MM-DD
//       const parts = dateStr.split("/");
//       if (parts.length === 3) {
//         const [day, month, year] = parts;
//         return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
//       }

//       // Fallback: gunakan tanggal hari ini
//       const today = new Date();
//       const year = today.getFullYear();
//       const month = String(today.getMonth() + 1).padStart(2, "0");
//       const day = String(today.getDate()).padStart(2, "0");
//       return `${year}-${month}-${day}`;
//     } catch (error) {
//       // Fallback ke tanggal hari ini jika error
//       const today = new Date();
//       const year = today.getFullYear();
//       const month = String(today.getMonth() + 1).padStart(2, "0");
//       const day = String(today.getDate()).padStart(2, "0");
//       return `${year}-${month}-${day}`;
//     }
//   };

//   // Gunakan tanggal hari ini jika params.tanggalTransaksi kosong
//   const transactionDate = params.tanggalTransaksi || new Date().toISOString().split('T')[0];

//   return {
//     out_date: formatDate(transactionDate),
//     cust_id: params.customer === "" ? 1 : Number(params.customer),
//     totalBayar: params.paidAmount,
//     channelId: paymentChannelMap[params.metodePembayaran] || 1,
//     payment_status: 1,
//     is_pending: params.is_pending,
//     diskon_total: params.diskonSubtotal,
//     diskon_type: 'percent',
//     ppn: params.ppn,
//     items: params?.cart?.map(item => ({
//       mtrl_code: item.mtrl_code,
//       qty: item.qty,
//       diskon: item.discountValue,
//       diskon_type: 'percent'
//     }))
//   };
// };


export const createTransaction = async (
  params: CreateTransactionParams
): Promise<ApiResponse<TransactionResponse>> => {

  const userData = getStoredUserData();
  const email = userData?.email || "";

  if (!email) {
    throw new Error("Email tidak ditemukan. Silakan login kembali.");
  }

  // console.info(params);


  const response = await axios.post<ApiResponse<TransactionResponse>>(
    `${import.meta.env.VITE_BASE_URL}/kasir/transaksi?email=${email}`,
    params
  );


  // ✅ Return full response sesuai format API
  if (response.data.success) {
    return response.data;
  }

  throw new Error(response.data.message || "Gagal membuat transaksi. Silakan coba lagi.");
};


export const updateTransaction = async (
  params: CreateTransactionParams
): Promise<ApiResponse<TransactionResponse>> => {

  const userData = getStoredUserData();
  const email = userData?.email || "";

  if (!email) {
    throw new Error("Email tidak ditemukan. Silakan login kembali.");
  }

  // console.info(params);
  const response = await axios.post<ApiResponse<TransactionResponse>>(
    `${import.meta.env.VITE_BASE_URL}/kasir/update-transaksi?email=${email}`,
    params
  );



  // ✅ Return full response sesuai format API
  if (response.data.success) {
    return response.data;
  }

  throw new Error(response.data.message || "Gagal membuat transaksi. Silakan coba lagi.");
};


// MOCK API
// export const createTransaction = async (
//   params: CreateTransactionParams
// ): Promise<ApiResponse<TransactionResponse>> => {
//   // Simulasi delay API call
//   await new Promise((resolve) => setTimeout(resolve, 1500));

//   // Simulasi error berdasarkan kondisi tertentu
//   // Uncomment untuk test error handling
//   // if (params.totalBayar > 1000) {
//   // throw new Error("Jumlah pembayaran minimal Rp 1.000");
//   // }

//   // Generate nomor transaksi palsu
//   const today = new Date();
//   const dateStr = today.toISOString().slice(2, 10).replace(/-/g, "");
//   const randomNum = Math.floor(Math.random() * 99999)
//     .toString()
//     .padStart(5, "0");
//   const outNo = dateStr + randomNum;

//   // Hitung kembalian (simulasi)
//   const totalBelanja = params.items?.reduce((total, item) => {
//     // Asumsi harga per item (untuk mock)
//     const hargaAsumsi = 50000;
//     const subtotal = hargaAsumsi * item.qty;
//     const diskonItem = subtotal * (item.diskon / 100);
//     return total + (subtotal - diskonItem);
//   }, 0) || 0;

//   const diskonTotal = totalBelanja * ((params.diskon_total || 0) / 100);
//   const totalSetelahDiskon = totalBelanja - diskonTotal;
//   const kembalian = (params.totalBayar || 0) - totalSetelahDiskon;

//   // Response sukses
//   return {
//     success: true,
//     message: "Transaksi berhasil disimpan",
//     data: {
//       out_no: outNo,
//       kembalian: Math.max(0, kembalian),
//     },
//   };
// };